import {
  WithStyles,
  Theme,
  createStyles,
  withStyles,
  Dialog,
  DialogTitle,
  TextField,
  DialogContent,
  Divider,
  DialogActions,
  Button,
  ListItemText,
  capitalize,
  MenuItem,
} from "@material-ui/core";
import * as React from "react";
import { blue } from "@material-ui/core/colors";
const drawerWidth = 340;
const styles = (theme: Theme) =>
  createStyles({
    root: {
      height: "100%",
      padding: 3,
    },
    button: {
      margin: theme.spacing(1),
      width: "30%",
      height: 48,
    },
    paper: {
      padding: theme.spacing(1) * 2,
      textAlign: "center",
      height: "100%",
      color: theme.palette.text.secondary,
    },
    control: {
      padding: theme.spacing(1) * 2,
    },
    appBar: {
      [theme.breakpoints.up("sm")]: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
      },
    },
    menuHideButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        display: "none",
      },
    },
    menuShowButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        display: "visible",
      },
      color: "black",
    },
    extendedIcon: {
      marginRight: theme.spacing(1),
    },
    sectionDesktop: {
      display: "none",
      [theme.breakpoints.up("md")]: {
        display: "flex",
      },
    },
    avatar: {
      backgroundColor: blue[100],
      color: blue[600],
    },
    toolbar: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      paddingTop: 0,
      paddingBottom: 8,
      minHeight: 64,
    },
    drawerPaper: {
      width: drawerWidth,
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },
    large: {
      margin: 10,
      width: theme.spacing(15),
      height: theme.spacing(15),
    },
  });
interface Props extends WithStyles<typeof styles> {
  open: any;
  dialogTitle: any;
  accessRules: any;
  selectedAccessRules: any;
  handleOnAssign: any;
  onClose: any;
}
class AssignPermissionDialog extends React.Component<Props> {
  state = {
    selectedPermission: "",
  };
  hasRuleAdded = (selectedPermssion: any) => {
    const { selectedAccessRules } = this.props;
    let hasRule = selectedAccessRules.filter((accessItem: any) => {
      return selectedPermssion === accessItem.permission;
    });
    return hasRule.length > 0;
  };

  componentDidUpdate = (prevProps: any, prevState: any) => {
    if (
      prevProps.selectedAccessRules &&
      prevProps.selectedAccessRules.length !==
        this.props.selectedAccessRules.length
    ) {
      this.setState({
        selectedPermission: "",
      });
    }
  };

  render() {
    const { open, accessRules, onClose, handleOnAssign, dialogTitle } =
      this.props;
    return (
      <Dialog
        open={open}
        keepMounted={true}
        onClose={() => onClose()}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
        fullWidth={true}
      >
        <DialogTitle id="simple-dialog-title">{dialogTitle}</DialogTitle>
        <Divider />
        <DialogContent>
          <div style={{ width: "100%" }}>
            <TextField
              select
              label={"Permission to Assign"}
              margin="dense"
              value={
                this.state.selectedPermission
                  ? this.state.selectedPermission
                  : ""
              }
              error={
                this.hasRuleAdded(this.state.selectedPermission) ? true : false
              }
              helperText={
                this.hasRuleAdded(this.state.selectedPermission)
                  ? `No need to assign this permision [${this.state.selectedPermission}]`
                  : ""
              }
              onChange={(event) => {
                this.setState({
                  selectedPermission: event.target.value,
                });
              }}
              fullWidth
            >
              {accessRules.map((option: any, index: any) => {
                if (
                  option.permission &&
                  option.permission.split(":").length > 1
                ) {
                  let perm = option.permission.split(":");
                  return (
                    <MenuItem key={option.permission} value={option.permission}>
                      <div
                        style={{
                          display: "flex",
                          flex: 1,
                          flexDirection: "row",
                          justifyContent: "space-between",
                        }}
                      >
                        <ListItemText
                          primary={"Field"}
                          secondary={"Permission Type"}
                        />
                        <ListItemText
                          style={{ textAlign: "end" }}
                          primary={capitalize(perm[0])}
                          secondary={capitalize(perm[1])}
                        />
                      </div>
                    </MenuItem>
                  );
                } else {
                  return <div key={`MentuItem-${index.toString()}`} />;
                }
              })}
            </TextField>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              this.setState({
                selectedPermission: "",
              });
              onClose();
            }}
          >
            {"CANCEL"}
          </Button>
          <Button
            disabled={
              this.hasRuleAdded(this.state.selectedPermission) ? true : false
            }
            onClick={() => {
              this.setState({
                selectedPermission: "",
              });
              onClose();
              handleOnAssign(this.state.selectedPermission);
            }}
          >
            {"ASSIGN"}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
export default withStyles(styles)(AssignPermissionDialog);
